import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Rbac from '../../../components/Rbac';
import tokens from './tokens';
import pairs from './pairs';
import tags from './tags';
import zones from './zones';

const Management = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      {Rbac.hasPermission('view_exchange-management') ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/tokens`}/> :
        Rbac.hasPermission('view_tag') ?
          <Redirect exact from={`${match.url}/`} to={`${match.url}/tags`}/> :
          <Redirect exact from={`${match.url}/`} to={`${match.url}/zones`}/>
      }
      <Route path={`${match.url}/tokens`} component={tokens}/>
      <Route path={`${match.url}/pairs`} component={pairs}/>
      <Route path={`${match.url}/tags`} component={tags}/>
      <Route path={`${match.url}/zones`} component={zones}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default Management;
